import { createHashRouter } from "react-router-dom";
import Login from "./pages/auth/Login";
import { ProtectedRoute } from "./ProtectedRoute";
import Root from "./Root";
import VerifyForgotEmail from "./pages/auth/forgot-password/VerifyForgotEmail";
import NewPassword from "./pages/auth/forgot-password/NewPassword";
import ForgotPassword from "./pages/auth/forgot-password/ForgotPassword";
import PasswordResetSuccess from "./pages/auth/forgot-password/PasswordResetSuccess";
import DashboardMain from "./pages/dashboard-main/DashboardMain";
import Signup from "./pages/auth/signup/Signup";
import Group from "./pages/personnel/Group";
import PersonnelUploadList from "./pages/personnel/PersonnelUploadList";
import PersonnelAdd from "./pages/personnel/PersonnelAdd";
import PersonnelFolderView from "./pages/personnel/PersonnelFolderView";
import AttendanceEntriesTable from "./pages/employee-attendance/AttendanceEntriesTable";
import AttendanceDetailsTable from "./pages/employee-attendance/attendance-details/AttendanceDetailsTable";
import CompanyBranchTable from "./pages/staff-setting/company-branch/CompanyBranchTable";
import CompanyDepartmentTable from "./pages/staff-setting/company-department/CompanyDepartmentTable";
import CompanySectionTable from "./pages/staff-setting/company-section/CompanySectionTable";
import StaffStatusTable from "./pages/staff-setting/staff-status/StaffStatusTable";
import GradeTable from "./pages/staff-setting/grade/GradeTable";
import PositionTable from "./pages/staff-setting/positions/PositionTable";
import EngagementTable from "./pages/staff-setting/engagement-term/EngagementTable";
import CategoryTable from "./pages/staff-setting/staff-category/CategoryTable";
import PayrollTable from "./pages/payroll-setting/payroll-type/PayrollTable";
import FiscalTable from "./pages/payroll-setting/fiscal-years/FiscalTable";
import FiscalPeriodTable from "./pages/payroll-setting/fiscal-period/FiscalPeriodTable";
import BankTable from "./pages/payroll-setting/banks/BankTable";
import BankBranchTable from "./pages/payroll-setting/bank-branch/BankBranchTable";
import PayslipHeadersTable from "./pages/payroll-setting/payslip-headers/PayslipHeadersTable";
import PayrollItemTable from "./pages/payroll-setting/payroll-items/PayrollItemTable";
import FormulasTable from "./pages/payroll-setting/formulas/FormulasTable";
import RolesErrorPage from "./components/RolesErrorPage";
import TaxRatesTable from "./pages/payroll-setting/tax-rates/TaxRatesTable";
import NhifRatesTable from "./pages/payroll-setting/nhif-rates/NhifRatesTable";
import LeaveTypeTable from "./pages/leave-management/leave-type/LeaveTypeTable";
import LeaveDayTable from "./pages/leave-management/leave-days/LeaveDayTable";
import LeaveScheduleTable from "./pages/leave-management/leave-schedule/LeaveScheduleTable";
import LeaveApplicationTable from "./pages/leave-management/leave-application/LeaveApplicationTable";
import StaffBankTable from "./pages/transactions/staff-banks/StaffBankTable";
import StaffExemptsTable from "./pages/transactions/staff-exempts/StaffExemptsTable";
import WefTable from "./pages/transactions/wef/WefTable";
import AddWef from "./pages/transactions/wef/modal/AddWef";
import StaffTransactionTable from "./pages/transactions/staff-transactions/StaffTransactionTable";
import PayslipMessageTable from "./pages/transactions/payslip-messages/PayslipMessageTable";
import PayrollPaymentTable from "./pages/transactions/payroll-payments/PayrollPaymentTable";
import StaffNetTable from "./pages/transactions/payroll-payments/StaffNetTable";
import PaymentList from "./pages/payment/PaymentList";
import CasualTypeTable from "./pages/casual-management/casual-types/CasualTypeTable";
import CasualTable from "./pages/casual-management/casual-profile/CasualTable";
import CasualAdd from "./pages/casual-management/casual-profile/CasualAdd";
import Casual from "./pages/casual-management/casual-profile/Casual";
import AttendanceTable from "./pages/casual-management/casual-attendance/AttendanceTable";
import CasualAttendanceDetailsTable from "./pages/casual-management/casual-attendance/CasualAttendanceDetailsTable";
import CasualPaymentTable from "./pages/casual-management/casual-payments/CasualPaymentTable";
import PaymentLinesTable from "./pages/casual-management/casual-payments/PaymentLinesTable";
import UsersTable from "./pages/admin/users/UsersTable";
import PaymentPage from "./pages/payment/PaymentPage";
import MainReports from "./pages/reports/MainReports";
import LandingList from "./pages/landing/LandingList";
import AttendanceMap from "./pages/attendance-map/AttendanceMap";
import DirectPaymentDetailsTable from "./pages/payment/DirectPayment/single-payment/details/DirectPaymentDetailsTable";
import WalletUserTable from "./pages/payment/wallet-user/WalletUserTable";
import ShiftScheduleTable from "./pages/shift-management/shift-schedule/ShiftScheduleTable";
import ShiftTypeTable from "./pages/shift-management/shift-type/ShiftTypeTable";
import DirectPaymentList from "./pages/payment/DirectPayment/DirectPaymentList";
import AttendanceUploadList from "./pages/employee-attendance/AttendanceUploadList";
import AttendanceSummary from "./pages/transactions/staff-transactions/AttendanceSummary";
import StoreItemTable from "./pages/asset-management/StoreItemTable";
import LedgerDetailsTable from "./pages/asset-management/ledger-details/LedgerDetailsTable";
import FixedAssetDetails from "./pages/asset-management/fixed-assets/FixedAssetDetails";
import FixedAssetTable from "./pages/asset-management/fixed-assets/FixedAssetTable";
import StoreRequestTable from "./pages/asset-management/store-request/StoreRequestTable";
import StoreRequestDetails from "./pages/asset-management/store-request/StoreRequestDetails";
import AssetTransferTable from "./pages/asset-management/asset-transfer/AssetTransferTable";
import AssetTransferDetails from "./pages/asset-management/asset-transfer/AssetTransferDetails";
import Organogram from "./pages/personnel/organogram/Organogram";
import ShiftScheduleUploadList from "./pages/shift-management/shift-schedule/ShiftScheduleUploadList";
import AuditTrailTable from "./pages/audit/AuditTrailTable";
import ShiftRequestTable from "./pages/shift-management/shift-request/ShiftRequestTable";
import JobsTable from "./pages/recruitment/jobs/JobsTable";
import JobAddList from "./pages/recruitment/jobs/add/JobAddList";
import CareerList from "./pages/public-careers/CareerList";
import CareerViewList from "./pages/public-careers/view/CareerViewList";
import ApplicationStepper from "./pages/public-careers/view/application/ApplicationStepper";
import ExperienceTable from "./pages/setup/experience/ExperienceTable";
import OccupationTable from "./pages/setup/occupation/OccupationTable";
import QualificationTable from "./pages/setup/qualification/QualificationTable";
import StudyTable from "./pages/setup/job-study/StudyTable";
import JobTypeTable from "./pages/setup/job-type/JobTypeTable";
import WorkStyleTable from "./pages/setup/work-style/WorkStyleTable";
import EmploymentTermsTable from "./pages/setup/employment-terms/EmploymentTermsTable";
import ActivityTable from "./pages/recruitment/activity/ActivityTable";
import ActivityStepper from "./pages/recruitment/activity/add/ActivityStepper";
import RecruitmentProcessTable from "./pages/setup/recruitment-process/RecruitmentProcessTable";
import PanelList from "./pages/recruitment/panel/PanelList";
import RolesTable from "./pages/setup/roles/RolesTable";
import ActivityView from "./pages/recruitment/activity/view/ActivityView";
import LoginSeeker from "./pages/public-careers/auth/LoginSeeker";
import RegisterSeeker from "./pages/public-careers/auth/RegisterSeeker";
import LoginOtp from "./pages/auth/LoginOtp";
import SelectOrganization from "./pages/auth/SelectOrganization";

export const router = createHashRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      {
        path: "/",
        element: <Login />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/select-organization",
        element: <SelectOrganization />,
      },

      {
        path: "/login-otp",
        element: <LoginOtp />,
      },

      {
        path: "/forgot-password",
        element: <ForgotPassword />,
      },
      {
        path: "/verify-forgot-email",
        element: <VerifyForgotEmail />,
      },
      {
        path: "/new-password",
        element: <NewPassword />,
      },
      {
        path: "/password-reset-success",
        element: <PasswordResetSuccess />,
      },
      {
        path: "/signup",
        element: <Signup />,
      },

      //E-recruitment
      {
        path: "/recruitment/career-list",
        element: <CareerList />,
      },
      {
        path: "/recruitment/career-view-list",
        element: <CareerViewList />,
      },
      {
        path: "/recruitment/application-stepper",
        element: <ApplicationStepper />,
      },
      {
        path: "/recruitment/login-seeker",
        element: <LoginSeeker />,
      },
      {
        path: "/recruitment/register-seeker",
        element: <RegisterSeeker />,
      },

      {
        element: <ProtectedRoute role={"EXECUTIVE"} />,
        children: [
          {
            path: "/dashboard-main",
            element: <DashboardMain />,
          },
          {
            path: "/group",
            element: <Group />,
          },
          {
            path: "/personnel/add",
            element: <PersonnelAdd />,
          },
          {
            path: "/personnel/folder",
            element: <PersonnelFolderView />,
          },
          {
            path: "/personnel/add/file-upload",
            element: <PersonnelUploadList />,
          },

          {
            path: "/attendance-entries",
            element: <AttendanceEntriesTable />,
          },

          {
            path: "/attendance-details",
            element: <AttendanceDetailsTable />,
          },

          {
            path: "/company-branch",
            element: <CompanyBranchTable />,
          },
          {
            path: "/company-department",
            element: <CompanyDepartmentTable />,
          },

          {
            path: "/company-section",
            element: <CompanySectionTable />,
          },

          {
            path: "/staff-status",
            element: <StaffStatusTable />,
          },
          {
            path: "/staff-grade",
            element: <GradeTable />,
          },
          {
            path: "/staff-position",
            element: <PositionTable />,
          },
          {
            path: "/enagement-terms",
            element: <EngagementTable />,
          },
          {
            path: "/staff-category",
            element: <CategoryTable />,
          },
          {
            path: "/payroll-type",
            element: <PayrollTable />,
          },
          {
            path: "/fiscal-year",
            element: <FiscalTable />,
          },
          {
            path: "/fiscal-period",
            element: <FiscalPeriodTable />,
          },
          {
            path: "/bank",
            element: <BankTable />,
          },
          {
            path: "/bank-branch",
            element: <BankBranchTable />,
          },
          {
            path: "/payslip-headers",
            element: <PayslipHeadersTable />,
          },

          {
            path: "/payroll-item",
            element: <PayrollItemTable />,
          },
          {
            path: "/payroll-formula",
            element: <FormulasTable />,
          },
          {
            path: "/roles-error-page",
            element: <RolesErrorPage />,
          },
          {
            path: "/tax-rate",
            element: <TaxRatesTable />,
          },
          {
            path: "/nhif-rate",
            element: <NhifRatesTable />,
          },
          {
            path: "/leave-types",
            element: <LeaveTypeTable />,
          },
          {
            path: "/leave-days",
            element: <LeaveDayTable />,
          },
          {
            path: "/leave-schedule",
            element: <LeaveScheduleTable />,
          },
          {
            path: "/leave-appplications",
            element: <LeaveApplicationTable />,
          },
          {
            path: "/staff-banks",
            element: <StaffBankTable />,
          },
          {
            path: "/staff-exempts",
            element: <StaffExemptsTable />,
          },
          {
            path: "/wef-entries",
            element: <WefTable />,
          },
          {
            path: "/add-wef-entries",
            element: <AddWef />,
          },
          {
            path: "/staff-transactions",
            element: <StaffTransactionTable />,
          },
          {
            path: "/payslip-messages",
            element: <PayslipMessageTable />,
          },
          {
            path: "/payroll-payments",
            element: <PayrollPaymentTable />,
          },
          {
            path: "/staff-net",
            element: <StaffNetTable />,
          },
          {
            path: "/ndovu-pay",
            element: <PaymentList />,
          },
          {
            path: "/payment-page",
            element: <PaymentPage />,
          },
          {
            path: "/direct-payment",
            element: <DirectPaymentList />,
          },

          {
            path: "/casual-types",
            element: <CasualTypeTable />,
          },
          {
            path: "/casual-profile",
            element: <Casual />,
          },
          {
            path: "/casual-add",
            element: <CasualAdd />,
          },
          {
            path: "/casual-attendance",
            element: <AttendanceTable />,
          },

          {
            path: "/casual-attendace-details",
            element: <CasualAttendanceDetailsTable />,
          },

          {
            path: "/casual-payment-details",
            element: <PaymentLinesTable />,
          },

          {
            path: "/casual-payments",
            element: <CasualPaymentTable />,
          },

          {
            path: "/users-list",
            element: <UsersTable />,
          },

          {
            path: "/main-reports",
            element: <MainReports />,
          },

          {
            path: "/attendance-map",
            element: <AttendanceMap />,
          },
          {
            path: "/direct-payment-details",
            element: <DirectPaymentDetailsTable />,
          },
          {
            path: "/wallet-users",
            element: <WalletUserTable />,
          },

          {
            path: "/shift-type",
            element: <ShiftTypeTable />,
          },

          {
            path: "/shift-schedule",
            element: <ShiftScheduleTable />,
          },

          {
            path: "/attendance/add/file-upload",
            element: <AttendanceUploadList />,
          },

          {
            path: "/attendance-summary/add/file-upload",
            element: <AttendanceSummary />,
          },

          {
            path: "/store-items",
            element: <StoreItemTable />,
          },

          {
            path: "/ledger-items",
            element: <LedgerDetailsTable />,
          },

          {
            path: "/fixed-assets",
            element: <FixedAssetTable />,
          },

          {
            path: "/fixed-assets-details",
            element: <FixedAssetDetails />,
          },

          {
            path: "/store-request",
            element: <StoreRequestTable />,
          },
          {
            path: "/store-request-details",
            element: <StoreRequestDetails />,
          },

          {
            path: "/asset-transfer",
            element: <AssetTransferTable />,
          },
          {
            path: "/asset-transfer-details",
            element: <AssetTransferDetails />,
          },
          {
            path: "/organogram",
            element: <Organogram />,
          },
          {
            path: "/shift-schedule/add/file-upload",
            element: <ShiftScheduleUploadList />,
          },

          {
            path: "/audit-trail",
            element: <AuditTrailTable />,
          },
          {
            path: "/shift-request",
            element: <ShiftRequestTable />,
          },

          //E-recruitment
          {
            path: "/recruitment/jobs-table",
            element: <JobsTable />,
          },
          {
            path: "/recruitment/job-add-list",
            element: <JobAddList />,
          },
          {
            path: "/recruitment/activity-list",
            element: <ActivityTable />,
          },
          {
            path: "/recruitment/activity-stepper",
            element: <ActivityStepper />,
          },
          {
            path: "/recruitment/panel-list",
            element: <PanelList />,
          },
          {
            path: "/recruitment/activity-view",
            element: <ActivityView />,
          },

          //setup

          {
            path: "/recruitment/experience-setup",
            element: <ExperienceTable />,
          },
          {
            path: "/recruitment/occupation-setup",
            element: <OccupationTable />,
          },
          {
            path: "/recruitment/qualification-setup",
            element: <QualificationTable />,
          },
          {
            path: "/recruitment/study-setup",
            element: <StudyTable />,
          },
          {
            path: "/recruitment/job-type-setup",
            element: <JobTypeTable />,
          },
          {
            path: "/recruitment/work-style-setup",
            element: <WorkStyleTable />,
          },
          {
            path: "/recruitment/employment-terms-setup",
            element: <EmploymentTermsTable />,
          },
          {
            path: "/recruitment/recruitment-process-setup",
            element: <RecruitmentProcessTable />,
          },
          {
            path: "/recruitment/roles-setup",
            element: <RolesTable />,
          },
        ],
      },
      {
        path: "*",
        element: <p>404 - Error: Page not found</p>,
      },
    ],
  },
]);
